export default "__VITE_ASSET__611d0168__"